import moment from 'moment';
import Constants from 'utils/Constants';

export class DateFormatter {
  static format(date, format) {
    if(!date) {
        throw new Error("Date to format must be supplied.")
    }
    if(!format || format===DateFormatter.JSON) {
      return moment(date).toDate().toJSON();
    }
    return moment(date).format(format);
  }
  static formatDate(date,format) {
    if(!format) {
      format=DateFormatter.SHORT_DATE;
    }
    return this.format(date,format);
  }
  static formatFullDate(date) {
    return this.format(date, DateFormatter.MEDIUM_DATE);
  }
  static formatTime(date,format) {
    if(!format) {
      format=DateFormatter.TIME_12;
    }
    return this.format(date,format)
  }
  static isAfter(first, second) {
	  return moment(first.toString()).isAfter(second, 'day');
  }
  static isBefore(first, second) {
	  return moment(first.toString()).isBefore(second, 'day');
  }
  static isBetween(date, first,second) {
	  return moment(date).isBetween(first,second);
  }
  static isSame(first, second){
    return moment(first).isSame(second);
  }
  static isSameOrAfter(first,second) {
	  return moment(first).isSameOrAfter(second);
  }
  static isSameOrBefore(first,second) {
	  return moment(first).isSameOrBefore(second);
  }
  static getAfter(date, unit){
    return moment(date).add(1, unit).toString()
  }
  static getBefore(date, unit){
    return moment(date).subtract(1, unit).toString()
  }
  static isValid(date,format) {
    return moment(date,format).isValid();
  }
  static parse(date,format) {
    return moment(date,format).toDate();
  }
  static convertServerDate(date, format) {
	  let datestr = date.split(/[-T.]/);
	  let formatted = new Date(datestr.slice(0,3).join('/') + ' ' + datestr[3]);
	  return moment(formatted).format(format);
  }
  static getDateFromMilliseconds(milliseconds) {
	  return moment(milliseconds).toDate();
  }
  static getDateFromMillisecondsInFormat(milliseconds, format) {
	  return moment(new Date(milliseconds)).format(format);
  }
  static groupDatesForRevenue(type, dates) {
	  let resultArr = [];
    let reverseArr = dates.slice();
    reverseArr.reverse();
	  if (type === Constants.unit.week) {
	    for (var i = 0; i < reverseArr.length; i++) {
	      if (i % 7 === 0) resultArr.push({label: reverseArr[i].label, value: reverseArr[i].value});
	    }
      return resultArr.reverse()
	  } else if (type === Constants.unit.month) {
      let month = moment(dates[0].label).month();
      let year = moment(dates[0].label).year();
      for (var j = 0; j < dates.length; j++) {
        if (moment(dates[j].label).month() !== month) {
          resultArr.push({label: moment().year(year).month(month).date(1).format('MMM DD YYYY'), value: dates[j].value});
          month = moment(dates[j].label).month();
          year = moment(dates[j].label).year();
        }
      }
      resultArr.push({label: moment().year(year).month(month).date(1).format('MMM DD YYYY'), value:dates[dates.length-1].value});
      return resultArr;
    }
  }
  static groupDatesForTickets(type, dates) {
    let resultArr = [];
    let reverseArr = dates.slice();
    reverseArr.reverse();
    if (type === 'WEEK') {
      let weekObj = {};
      for (let i = 1; i <= reverseArr.length; i++) {
        if (Object.keys(reverseArr[i-1]).length >= 1) {
          if (!weekObj.label) weekObj.label = reverseArr[i-1].label;
          for (let newKey in reverseArr[i-1]) {
            if (weekObj[newKey] && newKey !== 'label') {
              weekObj[newKey].totalRevenueAsDouble += reverseArr[i-1][newKey].totalRevenueAsDouble;
            } else if (newKey !== 'label') {
              weekObj[newKey] = reverseArr[i-1][newKey];
            }
          }
        }
        if (i % 7 === 0 && i !== 0) {
          resultArr.push(weekObj);
          weekObj = {};
        } else if (i === reverseArr.length) {
          resultArr.push(weekObj);
        }
      }
      return resultArr.reverse()
    } else if (type === 'MONTH') {
      console.log('dates', dates);
      let monthObj = {};
      let month = moment(dates[0].label).month();
      let year = moment(dates[0].label).year();
      for (let j = 0; j < dates.length; j++) {
        if (moment(dates[j].label).month() === month) {
          if (Object.keys(dates[j]).length > 1) {
            for (let newKey in dates[j]) {
              if (monthObj[newKey] && newKey !== 'label') {
                monthObj[newKey].totalRevenueAsDouble += dates[j][newKey].totalRevenueAsDouble;
              } else if (newKey !== 'label') {
                monthObj[newKey] = dates[j][newKey];
              }
            }
          }
        } else {
          monthObj.label = moment().year(year).month(month).date(1).format('MMM DD YYYY');
          resultArr.push(monthObj);
          monthObj = {};
          month = moment(dates[j].label).month();
          year = moment(dates[j].label).year();
          j--;
        }
        if (j === dates.length - 1) {
          monthObj.label = moment().year(year).month(month).date(1).format('MMM DD YYYY');
          resultArr.push(monthObj);
        }
      }
    }
    return resultArr;
  }

  static getLastYearDateFrom(date, format) {
	  return this.subtractMonths(date, format, 12).toDate();
  }
  static getDayBefore(date, format) {
	  return this.subtractDays(date, format, 1);
  }
  static subtractDays(date, format, numberOfDays) {
	  return moment(date,format).subtract(numberOfDays, 'days');
  }
  static subtractMonths(date, format, numberOfMonths) {
	  return moment(date,format).subtract(numberOfMonths, 'months');
  }

}

/*Built in date formates (Common)*/
DateFormatter.LONG_DATETIME='dddd MMMM Do YYYY, h:mm a';
DateFormatter.SHORT_DATETIME='MM/DD/YYYY h:mm a';
DateFormatter.SHORT_DATE='MM/DD/YYYY';
DateFormatter.MEDIUM_DATE='MMMM Do YYYY';
DateFormatter.LONG_DATE='dddd MMMM Do YYYY';
DateFormatter.MOBILE_DATE='ddd MMM D YYYY'
DateFormatter.MOBILE_DATETIME='ddd MMM D YYYY h:mm a'
DateFormatter.PRODUCTION_DISPLAY='ddd, MMM DD'
DateFormatter.GRAPH_DISPLAY='MMM DD YYYY';
DateFormatter.TICK_DISPLAY='MMM DD';
DateFormatter.MONTH_DISPLAY='MMM YYYY';

DateFormatter.SERVER_API='MMDDYYYY';
DateFormatter.TIME_12='h:mm a';
DateFormatter.TIME_24='HH:mm';
DateFormatter.JSON='json string';



// WEBPACK FOOTER //
// ./src/utils/DateFormatter.js